import React from 'react';
import { isIPadProOnSafari } from '../../helpers/Helper';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import DealsPageBooks from '@components/DealsPage/DealsPageBooks';
import "./CatalogDeals.css";

const CatalogDeals = (props) => {

  const {deals, siteDealsURL} = props.dealsData || {};
  const renderBooks = (books) => {
    if (props.isMobile || props.isTablet || isIPadProOnSafari()) {
      return (
        <Carousel
          showArrows={false}
          infiniteLoop
          showStatus={false}
          showThumbs={false}
        >
          {books}
        </Carousel>
      );
    } else {
      return <div className="deals">{books}</div>;
    }
  };

  const renderDeals = () => {
    if (deals?.length > 0) {
      const books = deals.map((book, idx) => (
        <DealsPageBooks
          key={idx}
          dealsPageBookProps={{
            ...book.props,
            renderPrimaryAuthors: true
          }}
        />
      ));
      return (
        <div className="catalog-deals">
          <div className="today-deals">TODAY'S BOOK DEALS</div>
          {renderBooks(books)}
          <div className="today-deals">
            <a target="_blank" rel="noopener" href={`https://earlybirdbooks.com/${siteDealsURL}`}>
            Discover More Great Deals on Early Bird Books, our partner site
              <img src={`${process.env.S3_IMAGE_URL}/chevron-blue.png`}/>
            </a>
          </div>
        </div>
      );
    }
  };

  return <React.Fragment>{renderDeals()}</React.Fragment>;
};

export default CatalogDeals;
